import { EchecApi } from '../partage/api/client';
import type { Boucle } from '../partage/api/types';
import { DEPLACEMENT_ECHOUE, DEPLACEMENT_REFUSE } from '../partage/vocabulaire';

/**
 * Ce que l'écran fait d'un déplacement qui n'a pas eu lieu (chantier `deplacer`) : une
 * **boucle** ouvre son panneau, réduit à « Ne pas déplacer » ; tout le reste **se dit**, sans
 * rouge. La fiche (`DeplacerBulle`) et l'inventaire lisent le refus de la même façon.
 */
export type RefusDeDeplacement = { sorte: 'boucle'; boucle: Boucle } | { sorte: 'dit'; mot: string };

export function lireLeRefus(erreur: unknown): RefusDeDeplacement {
  if (erreur instanceof EchecApi && erreur.code === 'cycle' && erreur.details) {
    return { sorte: 'boucle', boucle: erreur.details as Boucle };
  }
  // Les refus ordinaires du déplacement (`verifierLaDestination`, server/src/application/placement.ts)
  // arrivent en 422 ou 404 ; un refus attendu autre que la boucle arriverait en 200. Le reste
  // (réseau coupé, statut 0 ; serveur en panne, 5xx ; toute autre erreur) n'est pas passé.
  if (erreur instanceof EchecApi && (erreur.statut === 200 || REFUS_ORDINAIRES.has(erreur.code))) {
    return { sorte: 'dit', mot: DEPLACEMENT_REFUSE };
  }
  return { sorte: 'dit', mot: DEPLACEMENT_ECHOUE };
}

/** Les codes des refus ordinaires d'un déplacement, tels que le serveur les envoie. */
const REFUS_ORDINAIRES = new Set([
  'destination_impossible',
  'destination_dans_la_branche',
  'trop_profond',
  'destination_introuvable',
  'bulle_introuvable',
]);
